import React, { useState, useEffect } from 'react';
import { OptionalState } from '../../utils/ReactHelper';
import Logger from '../../../common/utils/Logger';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Navbar from 'react-bootstrap/Navbar';
import Container from 'react-bootstrap/Container';
import Image from 'react-bootstrap/Image';
import Nav from 'react-bootstrap/Nav';
import Offcanvas from 'react-bootstrap/Offcanvas';

import imgLogo from '../images/logo.png';
import Linker from '../../library/Linker';
import CommonHelper from '../../../common/utils/CommonHelper';
import { PagePath } from '../PagePath';

type Props = {
    linker: Linker;
    openPath: (path: string) => void;
    path: string;
};

type State = {
};

const StateDefault: State = {
};

const Header = (props: Props) => {

    const [state, setState] = useState(StateDefault);

    const updateState = (updates: Partial<State>) => {
        setState(OptionalState(state, updates));
    };

    useEffect(() => {
        new Promise(async (resolve, reject) => {
            return Promise.resolve();
        });
    }, []);

    const doLogout = async () => {
        await props.linker.Logout();
        props.openPath(PagePath.Home);
    };

    return (
        <>
            <Navbar collapseOnSelect expand='sm'>
                <Navbar.Brand>
                    <Image src={imgLogo} height={50}></Image>
                </Navbar.Brand>
                <Navbar.Toggle />
                <Navbar.Offcanvas>
                    <Offcanvas.Header closeButton>
                        <Offcanvas.Title>
                            <Navbar.Brand>
                                <Image src={imgLogo} height={50}></Image>
                            </Navbar.Brand>
                        </Offcanvas.Title>
                    </Offcanvas.Header>
                    <Offcanvas.Body>
                        <Nav className='me-auto' activeKey={props.path}>
                            <Nav.Link eventKey={PagePath.Home} onClick={() => props.openPath(PagePath.Home)}>
                                Home
                            </Nav.Link>
                            <Nav.Link eventKey={PagePath.Chart} onClick={() => props.openPath(PagePath.Chart)}>
                                Chart
                            </Nav.Link>
                        </Nav>
                        <Nav>
                            {props.linker.User &&
                                <>
                                    <Nav.Link>
                                        Welcome, {props.linker.User.firstName}
                                    </Nav.Link>
                                    <Nav.Link onClick={doLogout}>
                                        Logout
                                    </Nav.Link>
                                </>
                            }
                            {!props.linker.User &&
                                <>
                                    <Nav.Link eventKey={PagePath.AuthLogin} onClick={() => props.openPath(PagePath.AuthLogin)}>
                                        Login
                                    </Nav.Link>
                                </>}
                        </Nav>
                    </Offcanvas.Body>
                </Navbar.Offcanvas>
            </Navbar>
        </>
    );
};

export default Header;